import { MATERIAUX } from '@/common/constants';
import favicon from '@/materiaux/assets/favicon/favicon.ico';
import touch from '@/materiaux/assets/favicon/logo192.png';
import { ReactComponent as LogoMateriaux } from '@/materiaux/assets/logos/les-materiaux.svg';

const ThemeMateriaux = {
  Logo: LogoMateriaux,
  SmallLogo: LogoMateriaux,
  defaultI18n: MATERIAUX,
  favicon,
  manifest: `${process.env.PUBLIC_URL}/manifest.materiaux.json`,
  touch,
};

export default ThemeMateriaux;
